module.exports = __webpack_public_path__ + "static/anchor-c5fba749af692527673d7578a56ef3a8.pdf";